import translate from './translate'
export { Race, Action, MAX_LENGTH } from './translate'

export default translate
